<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import { useRouter } from 'vue-router/composables'
import { api } from '@/api'
import { useLoadingStore, useToastStore } from '@/stores'
import { $formatErrorMessage } from '@/helpers'
import { STORAGE_CUSTOM_THEME } from '@/constants'

const props = defineProps<{
  contentId: string
}>()

const { $toast } = useToastStore()
const { $showLoading, $hideLoading } = useLoadingStore()

const theme = useLocalStorage(STORAGE_CUSTOM_THEME, {
  background: '#FFF',
  size: 'md' as 'sm' | 'md' | 'lg' | 'xl',
})

const book = ref<GetKuaishouContentGetcontentdetailResponse['data']>()
async function fetchBook() {
  try {
    const { data } = await api.get<any, GetKuaishouContentGetcontentdetailResponse>('/kuaishou/content/getContentDetail', {
      params: {
        contentId: props.contentId,
      },
    })
    book.value = data
  }
  catch (error: any) {
    $toast($formatErrorMessage(error))
  }
}

const recommends = ref<GetKuaishouContentGetfeedcontentlistResponse['data']>([])
async function fetchRecommends() {
  try {
    const { data } = await api.get<any, GetKuaishouContentGetfeedcontentlistResponse>('/kuaishou/content/getFeedContentList?size=6')
    recommends.value = data
  }
  catch (error: any) {
    $toast($formatErrorMessage(error))
  }
}
onMounted(async () => {
  try {
    $showLoading()
    await Promise.all([
      fetchBook(),
      fetchRecommends(),
    ])
  }
  finally {
    $hideLoading()
  }
})

const router = useRouter()
function gotoHome() {
  router.back()
}
function gotoChapter(id: string) {
  router.replace({ path: '/chapter', query: { contentId: id, chapterId: '0' } })
}
</script>

<template>
  <div class="pt-10 min-h-screen" :style="{ background: theme.background }">
    <div v-if="book" class="h-full">
      <!-- Cover -->
      <div v-if="book?.finishStatus === 0" class="pt-10 text-center">
        <img class="w-30 mx-auto" src="@/assets/cover-book-pending.png" alt="图片:书籍连载中">
        <div class="mt-5 h-10 text-sm text-#7B7B7B">
          <p>本书未完结，作者努力码字中</p>
          <p>后续剧情更精彩，敬请期待后续更新吧！</p>
        </div>
      </div>
      <div v-else class="pt-10 text-center">
        <img class="w-30 mx-auto" src="@/assets/cover-book-finished.png" alt="图片:书籍已完结">
        <div class="mt-5 h-10 text-sm text-#7B7B7B">
          <p>本书已经完结</p>
        </div>
      </div>
      <!-- Action -->
      <div class="mt-30px flex items-center justify-center">
        <BizTrackClick
          name="bookFinished" type="button" :extra="{ contentId, finished: book?.finishStatus === 1 }"
          class="w-270px h-45px lh-45px text-white text-center bg-#FC3866 rounded-full" @click="gotoHome"
        >
          去首页看看
        </BizTrackClick>
      </div>
      <!-- Recommends -->
      <div v-if="recommends.length" class="mt-10 px-5">
        <p class="font-bold">
          热门书籍推荐
        </p>
        <div class="mt-4 grid grid-cols-3 gap-3">
          <div v-for="recommend in recommends" :key="recommend.id" @click="gotoChapter(recommend.id)">
            <img class="rounded-1 border border-#00000004 w-full aspect-5/7" :src="recommend.contentCoverUrl" alt="图片:书封">
            <p class="mt-2 text-sm truncate">
              {{ recommend.contentName }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
